// @ts-nocheck
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { createFileRoute } from '@tanstack/react-router';

function SageInvoiceList() {
  const router = useRouter();
  const { t, c } = router.query;
  useEffect(() => {
    if (t && c) router.replace(`/customerzone?t=${t}&c=${c}&tab=invoices`);
  }, [t, c]);
  return null;
}

export default SageInvoiceList;
export const Route = createFileRoute('/_customerzoneLayout/customerzone/sageinvoicelist')({ component: SageInvoiceList });
